import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Мороз Петро',
  role: 'Голова ради ветеранів'
}, {
  name: 'Литвиненко Борис',
  role: 'Заступник голови'
}, {
  name: 'Ткаченко Валентина',
  role: 'Секретар ради ветеранів'
}, {
  name: 'Гончаренко Микола',
  role: 'Член ради ветеранів'
}];
export function VeteransCouncil() {
  return <FederationMembersPage title="Рада ветеранів" subtitle="Об'єднання досвідчених альпіністів та скелелазів, які зробили значний внесок у розвиток спорту" members={members} data-id="element-784" />;
}